var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToggleClose = function SvgToggleClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.85 6a.65.65 0 0 1 .65-.65h9a.65.65 0 1 1 0 1.3h-9A.65.65 0 0 1 .85 6Z",
    fill: "currentColor"
  })));
};

export { SvgToggleClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiBmaWxsPSJub25lIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjg0OTYwOSA2LjAwMDFDMC44NDk2MDkgNS42NDExMSAxLjE0MDYyIDUuMzUwMSAxLjQ5OTYxIDUuMzUwMUwxMC40OTk2IDUuMzUwMUMxMC44NTg2IDUuMzUwMSAxMS4xNDk2IDUuNjQxMTEgMTEuMTQ5NiA2LjAwMDFDMTEuMTQ5NiA2LjM1OTA4IDEwLjg1ODYgNi42NTAxIDEwLjQ5OTYgNi42NTAxTDEuNDk5NjEgNi42NTAxQzEuMTQwNjIgNi42NTAxIDAuODQ5NjA5IDYuMzU5MDggMC44NDk2MDkgNi4wMDAxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";